export const personalInfo = {
  name: "Hasibur Rahman Safin",
  shortName: "SAFIN",
  title: "Full Stack Developer",
  roles: ["Full Stack Developer", "MERN Stack Developer", "Front End Developer", "Web Developer"],
  bio: "I'm a Full Stack Developer passionate about crafting efficient and scalable web applications. With expertise in JavaScript, Tailwind CSS, MongoDB, Express.js, React.js, Node.js, Next.js, Shadcn, Redux Toolkit, Firebase, PostgreSQL, MySQL, Mongoose, TypeScript, GSAP, C, C++, Python and Java — my focus is on optimizing database queries, designing robust APIs, and creating responsive user interfaces.",
  bio2: "I am a quick learner and always looking to expand my skill set. Excited to collaborate with others to create stunning applications.",
  location: "Dhaka, Bangladesh",
  email: "hasiburahmansafin76@gmail.com",
  github: "https://github.com/hr-safin",
  linkedin: "https://www.linkedin.com/in/hasibur-rahman-safin/",
  photo: "https://i.postimg.cc/VLRg6Fbf/my-Pic-Photo-Room-3-preview-rev-1.png",
};

export const frontendSkills = [
  { name: "HTML5", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
  { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
  { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
  { name: "TypeScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
  { name: "React JS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
  { name: "Next.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" },
  { name: "Redux Toolkit", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg" },
  { name: "Tailwind CSS", icon: "https://i.postimg.cc/Wp7r2w4y/png-transparent-tailwind-css-hd-logo-thumbnail-removebg-preview.png" },
  { name: "Shadcn UI", icon: "https://avatars.githubusercontent.com/u/139895814?s=200&v=4" },
  { name: "GSAP", icon: "https://i.postimg.cc/6qSB9P4V/tweenmax-png-cf27916e926fbb328ff214f66b4c8429.png" },
];

export const backendSkills = [
  { name: "Node.js", icon: "https://i.postimg.cc/YCLrL8rK/node-js-removebg-preview-1.png" },
  { name: "Express.js", icon: "https://i.postimg.cc/7LsHsbP5/136-1363736-express-js-icon-png-transparent-png-removebg-preview.png" },
  { name: "MongoDB", icon: "https://i.postimg.cc/rpRc063T/mongodb.png" },
  { name: "Mongoose", icon: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/mongoose/mongoose.png" },
  { name: "Firebase", icon: "https://i.postimg.cc/0NqN1Bh0/touchicon-180.png" },
  { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
  { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
];

export const systemSkills = [
  { name: "C", icon: "https://cdn.worldvectorlogo.com/logos/c-1.svg" },
  { name: "C++", icon: "https://cdn.worldvectorlogo.com/logos/c.svg" },
  { name: "Python", icon: "https://cdn.worldvectorlogo.com/logos/python-5.svg" },
  { name: "Java", icon: "https://cdn.worldvectorlogo.com/logos/java-4.svg" },
];

export const projects = [
  {
  id: 1, // use the next free id in your array
  title: "CourseTea",
  image: "https://i.postimg.cc/fyQJHnpK/course-Tea.png",
  tech: ["Next.js", "TypeScript", "Convex", "Better Auth", "Tailwind CSS", "Venture IT"],
  live: "https://coursetea.com",
  github: "",
  category: "Client Work",
  isClient: true,
},
{
  id: 2,
  title: "BICCI",
  image: "https://i.postimg.cc/XYjySWqW/bicci.png",
  tech: ["React", "TypeScript", "React Router", "Tailwind CSS", "Venture IT"],
  live: "https://bicci-it.com",
  github: "",
  category: "Client Work",
  isClient: true,
},
  
  {
    id: 3,
    title: "Time Ex Tours",
    image: "https://i.postimg.cc/xdwvQZgL/Screenshot-(424).png",
    tech: ["Tailwind CSS", "Next JS", "Typescript", "Sanity", "ShadCn", "Venture IT"],
    live: "https://timeexbd.com/",
    github: "",
    category: "Client Work",
    isClient: true,
  },
  {
    id: 4,
    title: "Daak Chithi",
    image: "https://i.postimg.cc/J7ZLRB7S/Screenshot-(425).png",
    tech: ["Tailwind CSS", "React JS", "React Router", "Material Tailwind", "Daak Chithi ORG"],
    live: "https://daakchithi.org/",
    github: "",
    category: "Client Work",
    isClient: true,
  },
  {
    id: 5,
    title: "Authentic Touch",
    image: "https://i.postimg.cc/90gGWd1k/Screenshot-(448).png",
    tech: ["Tailwind CSS", "Next JS", "Typescript", "Sanity", "ShadCn", "Venture IT"],
    live: "https://authentictouchbd.com/",
    github: "",
    category: "Client Work",
    isClient: true,
  },
  {
    id: 6,
    title: "Team Bertho",
    image: "https://i.postimg.cc/vTLGH5c8/Screenshot-177.png",
    tech: ["Tailwind CSS", "React JS", "React Router", "Material Tailwind", "Team Bertho ORG"],
    live: "https://teambertho.org/",
    github: "",
    category: "Client Work",
    isClient: true,
  },
  {
    
    id: 7,
    title: "Car Lagbe",
    image: "https://i.postimg.cc/y69T1Zng/car-lagbe.png",
    tech: ["Tailwind CSS", "Next JS", "Type Script", "ShadCN"],
    live: "https://car-lagbe.netlify.app/",
    github: "",
    category: "Next JS",
    isClient: false,
  },
  {
    
    id: 8,
    title: "Flamehaus",
    image: "https://i.postimg.cc/3rpTGrth/flame-house.png",
    tech: ["Tailwind CSS", "Next JS", "Type Script", "ShadCN"],
    live: "https://flamehaus.netlify.app/",
    github: "",
    category: "Next JS",
    isClient: false,
  },
  {
    id: 9,
    title: "Track N Parcel",
    image: "https://i.postimg.cc/ZnRzKvW6/Track-NParcel-About-Us-2.png",
    tech: ["Tailwind CSS", "React JS", "Express JS", "MongoDB"],
    live: "https://tracknparcel.netlify.app/",
    github: "https://github.com/hr-safin/TrackNParcel-Client",
    category: "MERN Stack",
    isClient: false,
  },
  {
    id: 10,
    title: "Event Academia",
    image: "https://i.postimg.cc/fy972sNr/Screenshot-300.png",
    tech: ["Tailwind CSS", "React JS", "Express JS", "MongoDB"],
    live: "https://clever-dusk-6d60d6.netlify.app/",
    github: "https://github.com/hr-safin/EventAcademia-Client",
    category: "MERN Stack",
    isClient: false,
  },
  {
    id: 11,
    title: "Chef Restaurant",
    image: "https://i.postimg.cc/RVSP1YVq/Screenshot-284.png",
    tech: ["Tailwind CSS", "React JS", "Express JS", "MongoDB"],
    live: "https://fancy-queijadas-88c8dc.netlify.app/",
    github: "https://github.com/hr-safin/Chef-Website-Client",
    category: "MERN Stack",
    isClient: false,
  },
  {
    id: 12,
    title: "Gadget World",
    image: "https://i.postimg.cc/fL5QV7dC/Screenshot-299.png",
    tech: ["Tailwind CSS", "React JS", "Express JS", "MongoDB"],
    live: "https://spectacular-froyo-07b066.netlify.app/",
    github: "https://github.com/hr-safin/GadgetWorld-Client",
    category: "MERN Stack",
    isClient: false,
  },
  {
    id: 13,
    title: "Skill Forge",
    image: "https://i.postimg.cc/WpyC9smw/Skill-Forge-1.png",
    tech: ["Tailwind CSS", "React JS", "Express JS", "MongoDB"],
    live: "https://skill-forge.netlify.app/",
    github: "https://github.com/hr-safin/SkillForge-Client",
    category: "MERN Stack",
    isClient: false,
  },
  {
    id: 14,
    title: "TravelGo",
    image: "https://i.postimg.cc/Rhhc4K7D/Screenshot-178.png",
    tech: ["HTML", "Tailwind CSS", "React JS"],
    live: "https://jazzy-griffin-97edbc.netlify.app/",
    github: "",
    category: "React JS",
    isClient: false,
  },
  {
    id: 15,
    title: "Donation Campaign",
    image: "https://i.postimg.cc/GppYkvN1/Screenshot-181.png",
    tech: ["HTML", "Tailwind CSS", "React JS", "React Router JS"],
    live: "https://donation-campaign8.netlify.app/",
    github: "",
    category: "React JS",
    isClient: false,
  },
  {
    id: 16,
    title: "Tech Editor",
    image: "https://i.postimg.cc/V688xF8z/Screenshot-185.png",
    tech: ["HTML", "CSS", "Javascript", "DOM"],
    live: "https://tech-editor.netlify.app/",
    github: "",
    category: "JavaScript",
    isClient: false,
  },
  {
    id: 17,
    title: "Google Home Clone",
    image: "https://i.postimg.cc/tgVRQTnh/Screenshot-184.png",
    tech: ["HTML", "CSS"],
    live: "",
    github: "",
    category: "JavaScript",
    isClient: false,
  },
  {
    id: 18,
    title: "Typing Speed",
    image: "https://i.postimg.cc/gJ80RJYJ/Screenshot-183.png",
    tech: ["HTML", "CSS", "Bootstrap", "React JS"],
    live: "https://starlit-kringle-b3a088.netlify.app/",
    github: "",
    category: "React JS",
    isClient: false,
  },
  {
    id: 19,
    title: "Two Good",
    image: "https://i.postimg.cc/XvXGZ4GY/Screenshot-182.png",
    tech: ["HTML", "CSS", "Javascript", "Locomotive JS"],
    live: "https://timely-dodol-3c17e8.netlify.app/",
    github: "",
    category: "JavaScript",
    isClient: false,
  },
];

export const education = [
  {
    id: 1,
    degree: "B.Sc. in Computer Science",
    institution: "BRAC University",
    status: "Currently Pursuing",
    statusColor: "text-yellow-400",
  },
  {
    id: 2,
    degree: "Front-End Development",
    institution: "Programming Hero (Level-1)",
    status: "Completed",
    statusColor: "text-green-400",
  },
  {
    id: 3,
    degree: "Full Stack Development",
    institution: "Programming Hero (Level-2)",
    status: "Completed",
    statusColor: "text-green-400",
  },
  {
    id: 4,
    degree: "CSE Fundamentals",
    institution: "Phitron (Competitive Programming)",
    status: "Completed",
    statusColor: "text-green-400",
  },
  
];
